import { EventActionRequestType } from "../../../types/types";
import { api } from "../api";

/**
 * saveEventAction - Function that saves on database a new avent-action (automatic command)  
 * /devices/event-actions/{deviceId}  
 * method POST 
 * @async-function
 */
const saveEventAction = async (token: string, deviceId: number, model: EventActionRequestType) => {
    const response = await api.post(
        `/devices/event-actions/${deviceId}`, {
            ...model
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default saveEventAction;